import React from 'react';
import { createFromValidationResolver } from '@cp/utils/form/resolver';
import { SupportSendMessageRequest } from '@common/model/support/message.request';
import { SupportSendMessageForm, SupportSendMessageFormProps, coreSupportApi } from 'src/entities/support';
import { useApiServerErrorHandler } from 'src/shared/apiServer';
import { useModal } from 'src/shared/modalProvider';
import { INFO_MODAL_NAME } from 'src/app/shared/components/modals/info/const';

const resolver = createFromValidationResolver(SupportSendMessageRequest);

export const SupportSendMessage: React.FC = () => {
  const handleApiServerError = useApiServerErrorHandler();
  const [sendMessage] = coreSupportApi.useSendMessageToSupportMutation();
  const { openModal } = useModal();

  const handleSend: SupportSendMessageFormProps['onSend'] = async (values, form) => {
    const response = await sendMessage(values);

    if ('error' in response) {
      handleApiServerError(response.error, { form });
    } else {
      openModal(INFO_MODAL_NAME, { message: 'Сообщение отправлено!' });
    }
  };

  return <SupportSendMessageForm onSend={handleSend} resolver={resolver} />;
};
